import React from 'react';

const SearchBar = ({ leadId, setLeadId, onSearch, loading }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="search-bar">
      <div className="search-container">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={leadId}
            onChange={(e) => setLeadId(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter Lead ID"
            className="search-input"
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading || !leadId.trim()}
            className="search-button"
          >
            {loading ? (
              <div style={{
                width: '20px',
                height: '20px',
                border: '2px solid #f26841',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
            ) : (
              <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchBar;
